import {useState} from "react"
import { nanoid } from "nanoid"
import Button from "../Button"
import AddSlotModal from "../modal/AddSlotModal"
import { Dayjs } from "dayjs"


const ScheduleInterview = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleModalOpen = () => {
    setIsModalOpen(!isModalOpen)
  }
  return (
    <>
        <AddSlotModal isOpen={isModalOpen} onClose={handleModalOpen} />
        <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[65vh] mt-5 p-5">
            <div className = "grid grid-cols-[25%_20%_20%_35%] px-10 w-[100%] text-lg font-bold py-2 border-b-2 border-b-light-blue">
              <p>Date</p>
              <p>Time</p>
              <p>Status</p>
              <div></div>
            </div>
            <div>
              {interviewSlots.length === 0 && <div className = "w-[60%] mx-auto text-center italic mt-16">Schedule a tutorial. Click the Add Slot button</div>}
              {interviewSlots.map(interview => <InterviewSlot date={interview.date} time={interview.time} status={interview.status} />)}
              <div className="mt-5 w-[20%] mx-auto text-center">
                <Button onClick = {handleModalOpen} disabled = {interviewSlots.length > 2}>Add Slot</Button>
              </div>
            </div>
        </div>
        </>
  )
}

export default ScheduleInterview

const InterviewSlot = ({date, time, status}: {
  date: string
  time: string
  status: string
}) => {
  return (
    <div className = "grid grid-cols-[25%_20%_20%_18%_17%] px-8 pb-2 my-5 border-b-[0.5px] border-b-light-blue">
      <p>{date}</p>
      <p>{time}</p>
      <p>{status}</p>
      <div className = "flex justify-center items-center"><Button>Edit</Button></div>
      <div className = "flex justify-center items-center"><Button>Delete</Button></div>
    </div>
  )
}

export const interviewSlots : {
  id: (size?: number | undefined) => string
  date: string
  time: string
  status: string
}[] = []

export const addSlot = (value: Dayjs | null) => {
  interviewSlots.push({
    id: nanoid,
    date: value?.toDate().toString().split("").slice(0,16).join().replaceAll(",","") || "",
    time: `${value?.get('hour')}:${value?.get('minute')}`,
    status: "Pending"
  })
}